import { render, staticRenderFns } from "./PDFUpload.vue?vue&type=template&id=46452bb8&scoped=true&"
import script from "./PDFUpload.vue?vue&type=script&lang=ts&"
export * from "./PDFUpload.vue?vue&type=script&lang=ts&"
import style0 from "./PDFUpload.vue?vue&type=style&index=0&id=46452bb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46452bb8",
  null
  
)

export default component.exports